/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class LoginApi  {
    static getInstance() {
        if (!this.instance) this.instance = new LoginApi ()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 登录
    async login (param){
        let url = `/api/auth/access_token`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取验证码
    async getCaptcha (){
        let url = `/api/auth/captcha`
        let result = await this.getData(url,{},'GET')
        return result
    }
}

export {
    LoginApi 
}